(function () {
  'use strict';

  // Load more — append the next page of products into the grid.
  function initLoadMore() {
    var grid = document.getElementById('product-grid');
    var loadMoreWrap = document.querySelector('.col-loadmore');
    if (!grid || !loadMoreWrap) return;

    loadMoreWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-load-more');
      if (!btn || btn.disabled) return;

      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      btn.disabled = true;
      var origLabel = btn.getAttribute('data-label') || btn.textContent.trim();
      btn.textContent = 'Loading...';

      fetch(nextUrl)
        .then(function (resp) { return resp.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newGrid = doc.getElementById('product-grid');
          if (newGrid) {
            // norsu 2026-11-04 (/cro): keep sold-out cards below EVERY in-stock card, not just
            // below the ones on their own page. The Liquid grid can only sort within the page it
            // renders (paginate caps at 50), so each appended page would otherwise drop its own
            // sold-out run into the middle of the list. Incoming in-stock cards are inserted
            // ahead of the first sold-out card already in the grid; sold-out cards go to the end.
            // data-soldout is set in snippets/norsu-product-card.liquid from product.available,
            // the same test the server-side two-pass uses.
            var incoming = Array.from(newGrid.children).map(function (child) {
              return child.cloneNode(true);
            });
            var firstSoldOut = grid.querySelector(':scope > [data-soldout]');
            incoming.forEach(function (card) {
              var isSoldOut = card.hasAttribute && card.hasAttribute('data-soldout');
              if (!isSoldOut && firstSoldOut) {
                grid.insertBefore(card, firstSoldOut);
              } else {
                grid.appendChild(card);
                if (isSoldOut && !firstSoldOut) firstSoldOut = card;
              }
            });
          }

          var newLoadMore = doc.querySelector('.col-loadmore');
          if (newLoadMore) {
            loadMoreWrap.innerHTML = newLoadMore.innerHTML;
          } else {
            loadMoreWrap.style.display = 'none';
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = origLabel;
        });
    });
  }

  // Quick add — wire up the .js-quick-add buttons on single-variant product cards.
  // Posts to /cart/add.js then opens the WAU "ajax-cart" slideout (falls back to /cart).
  function openCartDrawer() {
    var t = window.theme;
    if (t && t.cart && t.cart.ajaxCart) {
      try {
        if (typeof t.cart.ajaxCart.getAjaxCart === 'function') t.cart.ajaxCart.getAjaxCart();
        if (typeof t.cart.ajaxCart.showDrawer === 'function') { t.cart.ajaxCart.showDrawer(); return true; }
        if (typeof t.cart.ajaxCart.showModal === 'function') { t.cart.ajaxCart.showModal(); return true; }
      } catch (e) { /* fall through */ }
    }
    var trigger = document.querySelector('.js-mini-cart-trigger, .js-slideout-open[data-wau-slideout-target="ajax-cart"], [aria-controls="slideout-ajax-cart"], [aria-controls="modal-ajax-cart"]');
    if (trigger) { trigger.click(); return true; }
    return false;
  }

  function initQuickAdd() {
    // Delegated so it also covers cards appended by "load more".
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-quick-add');
      if (!btn || btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      e.preventDefault();
      btn.disabled = true;
      btn.classList.add('is-loading');

      var item = { id: variantId, quantity: 1 };
      /* Pre-order (2026-09-28). Globo PreOrder only tags/emails an order when the line
         carries the two properties its own PDP button writes; quick add never goes
         through that button. The card flags pre-order variants (data-preorder, see
         norsu-product-card.liquid) so we write the same properties Globo would. */
      if (btn.getAttribute('data-preorder') === '1') {
        item.properties = { '_is_preorder': 'Pre-order item', '_preorder_locale': 'en' };
      }

      /* Add-on attribution (2026-11-04). The /collections/mugs "Fill it" shelf is a new
         add-on surface, and the attach scorecard reads the _addon / _addon_from line
         properties the PDP card writes — so a quick-add tile carrying data-addon stamps
         the same pair. Nothing else sets these attributes, so no existing card changes. */
      var addonKey = btn.getAttribute('data-addon');
      if (addonKey) {
        item.properties = item.properties || {};
        item.properties['_addon'] = addonKey;
        var addonFrom = btn.getAttribute('data-addon-from');
        if (addonFrom) { item.properties['_addon_from'] = addonFrom; }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      }).then(function () {
        if (!openCartDrawer()) { window.location.href = '/cart'; return; }
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }).catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        window.location.href = '/cart';
      });
    });
  }

  function initCardCarousel() {
    var THRESHOLD = 35;
    var pendingSwipeCard = null;

    // Slides 2+ ship with data-bg instead of a background-image so the page
    // doesn't download every carousel image upfront.
    function hydrateSlides(card) {
      card.querySelectorAll('.col-card__slide[data-bg]').forEach(function (s) {
        s.style.backgroundImage = "url('" + s.getAttribute('data-bg') + "')";
        s.removeAttribute('data-bg');
      });
    }

    // Pre-warm on hover/touch so images are ready before a swipe or arrow click
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('.col-card');
      if (card) hydrateSlides(card);
    }, { passive: true });

    function goTo(card, idx) {
      hydrateSlides(card);
      var media = card.querySelector('.col-card__media');
      if (!media) return;
      var slides = media.querySelectorAll('.col-card__slide');
      var dots = media.querySelectorAll('.col-card__dot');
      var count = slides.length;
      if (count < 2) return;
      idx = (idx + count) % count;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      media.setAttribute('data-slide', idx);
    }

    // Arrow clicks — inside col-card__media (inside <a>), so must prevent navigation
    document.addEventListener('click', function (e) {
      var arr = e.target.closest('.col-card__arr');
      if (!arr) return;
      e.preventDefault();
      e.stopPropagation();
      var card = arr.closest('.col-card');
      if (!card) return;
      var media = card.querySelector('.col-card__media');
      var current = parseInt(media.getAttribute('data-slide') || '0', 10);
      goTo(card, current + (arr.classList.contains('col-card__arr--next') ? 1 : -1));
    });

    // Touch swipe — all listeners passive so they never block scroll
    document.addEventListener('touchstart', function (e) {
      var card = e.target.closest('.col-card');
      if (!card) return;
      card._tx = e.touches[0].clientX;
      card._ty = e.touches[0].clientY;
      pendingSwipeCard = null;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      var card = e.target.closest('.col-card');
      if (!card || card._tx == null) return;
      var dx = e.changedTouches[0].clientX - card._tx;
      var dy = e.changedTouches[0].clientY - card._ty;
      card._tx = null;
      if (Math.abs(dy) > Math.abs(dx) || Math.abs(dx) < THRESHOLD) return;
      var media = card.querySelector('.col-card__media');
      if (!media || parseInt(media.getAttribute('data-slide-count') || '1', 10) < 2) return;
      var current = parseInt(media.getAttribute('data-slide') || '0', 10);
      goTo(card, current + (dx < 0 ? 1 : -1));
      pendingSwipeCard = card;
    }, { passive: true });

    // Block the synthetic click iOS fires after a touch-swipe on an <a>
    document.addEventListener('click', function (e) {
      if (pendingSwipeCard && pendingSwipeCard.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        pendingSwipeCard = null;
      }
    }, true);
  }

  function initSortSelect() {
    var sortSelect = document.getElementById('sort-select');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init() {
    initLoadMore();
    initQuickAdd();
    initSortSelect();
    initCardCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
